import { render, staticRenderFns } from "./ChatComment.vue?vue&type=template&id=b4e723f0&"
import script from "./ChatComment.vue?vue&type=script&lang=js&"
export * from "./ChatComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports